import { HelpCircle } from "lucide-react";
import { MultiSelectCombobox } from "@/components/workflow/common/MultiSelectCombobox";
import { DocumentUploadSection } from "@/components/workflow/common/DocumentUploadSection";
import type { DocumentMetadata } from "@/contexts/WizardContext";

interface CertificationsFormProps {
  generalInfo: any;
  updateGeneralInfo: (updates: any) => void;
  isLocked?: boolean;
}

const CERTIFICATIONS = [
  "ISO 14001 (Environmental Management)",
  "ISO 45001 (Health & Safety)",
  "ISO 50001 (Energy Management)",
  "B Corp Certification",
  "Fairtrade",
  "Rainforest Alliance",
  "Organic Certification",
];

export function CertificationsForm({ generalInfo, updateGeneralInfo, isLocked }: CertificationsFormProps) {
  const selected: string[] = generalInfo.sustainabilityCertifications ?? [];

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2">
        <h3 className="text-sm font-bold text-slate-700">Sustainability Certifications</h3>
        <HelpCircle className="h-4 w-4 text-slate-600" />
      </div>

      <MultiSelectCombobox
        options={CERTIFICATIONS}
        value={selected}
        onChange={(certs) => updateGeneralInfo({ sustainabilityCertifications: certs })}
        placeholder="Add certification..."
        disabled={isLocked}
      />

      {selected.length > 0 && (
        <div className="pt-2">
          <DocumentUploadSection
            fieldIdentifier="general-certification"
            documents={generalInfo.certificationDocuments || []}
            onDocumentsChange={(docs: DocumentMetadata[]) => updateGeneralInfo({ certificationDocuments: docs })}
            currentTab="general"
            label="Certification Documents"
            description="Upload certificates if available to support your sustainability certifications."
            accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
            maxFiles={10}
            className="rounded-2xl border border-slate-200 bg-slate-50 p-4"
            itemClassName="rounded-2xl border border-slate-200 bg-white p-3"
            actionButtonClassName="h-9 rounded-2xl border-slate-200 bg-white px-4 text-sm font-medium text-slate-600 shadow-none hover:bg-slate-100"
          />
        </div>
      )}
    </div>
  );
}
